import log from 'salvo-lite/log'
import Video from '../components/Video'

class Videos {
    constructor (components) {
        log.debug(this.constructor.name, 'Constructing', components)
        this._components = components
        this._sliderBlocks = document.querySelectorAll('.videos-category')
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiated', this)
        if (this._sliderBlocks.length > 0) {
            this.triggerSliders()
        }
    }

    triggerSliders () {
        this.sliders = {}
        for (var i = 0; i < this._sliderBlocks.length; i++) {
            let idx = 'videosSlider-' + i
            this.sliders[idx] = this._components.getComponentsById(idx)

            this.sliders[idx]._elem.addEventListener('initiated', () => {
                for (let slide of this.sliders[idx]._slides) {
                    let video = slide.querySelector('[data-video]')
                    slide.video = new Video(window.__theme, video)
                    slide.video.init()
                }
            })
            this.sliders[idx].init()
        }
    }
}

export default Videos



// WEBPACK FOOTER //
// ./src/scripts/pages/Videos.js